import { jsx as _jsx } from "react/jsx-runtime";
import "@/styles/global.less";
import "@ant-design/v5-patch-for-react-19";
import { ConfigProvider } from "antd";
import ruRU from "antd/locale/ru_RU";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
const container = document.getElementById("root");
if (!container)
    throw new Error("Failed to find the root element");
const root = createRoot(container);
root.render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, { children: _jsx(ConfigProvider, { locale: ruRU, children: _jsx(App, {}) }) }) }));
